import React, { useState } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { FormikTextField } from 'formik-material-fields';
import FormikSelectField from 'formik-material-fields/lib/FormikSelectField';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useTranslation } from 'react-i18next';
import { productTypeRawMaterial } from '../../Config/constants'
import { dataService } from '../../Services/data.service'
import { systemParameterSilos } from '../../Config/systemParameters'
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export default function RawMaterialsTable(props) {
    const classes = useStyles();

    const { t } = useTranslation();
    const [silos, setSilos] = useState([])

    useEffect(() => {
        dataService.getSystemParameterById(systemParameterSilos).then(parameter => {
            if (JSON.stringify(JSON.parse(parameter[0].value).silos) !== JSON.stringify(silos)) {
                setSilos(JSON.parse(parameter[0].value).silos.map(x => { return ({ label: x.name, value: x.id }) }))
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, []);

    const rows = props.productionOrder.bomIn.filter(x => JSON.parse(x.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeRawMaterial).map(m => {
        let productType = JSON.parse(m.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].ProductType        

        return (
            createData(productType, m.productReference, m.productDescription,m.productId, m.uom))
    }
    )

    function createData(type, code, description,id, uom) {
        return { type, code, description,id, uom };
    }

    const siloSelected = (event, id) => {
        let siloName = silos.find(x => x.value === event.target.value).label
        props.siloChanged(siloName, id)
    }

    return (
        <Table className={classes.table} aria-label="customized table">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.headCell}></TableCell>
                    <TableCell className={classes.headCell}></TableCell>
                    <TableCell className={classes.headCell}></TableCell>
                    <TableCell className={classes.headCell}>{t("From silo")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.name} className={classes.row}>
                        <TableCell className={classes.typeCell}>{t(row.type)}</TableCell>
                        <TableCell className={classes.infoCell}>{row.code}</TableCell>
                        <TableCell className={classes.infoCell}>{row.description}</TableCell>
                        <TableCell className={classes.siloCell}>
                            <FormikSelectField name={"silos"} className={classes.formikSelectField} onChange={(e) => siloSelected(e, row.id)} options={silos} />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    typeCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
        width: "20%"
    },
    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%"
    },
    quantityCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        paddingRight: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "11%"
    },
    siloCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        width: "30%",
        paddingTop: "10px",
        paddingRight: "15px",
        width: "20%"
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    },
    batchnumberTextField: {
        width: "100%"
    },
    quantityTextField: {
        width: "100%"
    },
    addMaterialAmounts: {
        width: "100%",
        textAlign: "center",
        marginTop: "40px"
    },
    formikSelectField: {
        width: "97%",
        height: "37px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "white",
            display: 'block'
        },
        marginBottom: "10px"

    },
}));